import { render } from "./HelpAccordion.vue?vue&type=template&id=15360613&scoped=true"
import script from "./HelpAccordion.vue?vue&type=script&lang=js"
export * from "./HelpAccordion.vue?vue&type=script&lang=js"

import "./HelpAccordion.vue?vue&type=style&index=0&id=15360613&lang=scss&scoped=true"

import exportComponent from "/app/tmp/blackhall/V3/v2026.5.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15360613"]])

export default __exports__